export default "__VITE_ASSET__Dz9yCn4k__"